import { render, staticRenderFns } from "./setPersonnel.vue?vue&type=template&id=25fd2810&scoped=true&"
import script from "./setPersonnel.vue?vue&type=script&lang=js&"
export * from "./setPersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fd2810",
  null
  
)

export default component.exports